// File: reactnodehelloworld/frontend/src/pages/Services.js
import React, { Component } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import './contact.css';



function Contant() {
  return (
    <div className="services-container">
        <Sidebar />
        <div className="services-content">
        <header className="App-header">
      <h2>Contact charu</h2>
      <p>Gmail : charuchander24@gmail.com</p>
      </header >
      </div>
    </div>
  );
}

export default Contant;
